type ClerkTokenGetter = (options?: { template?: string }) => Promise<string | null>

interface ClerkAuthorizationHeaderOptions {
  tokenTemplate?: string
  injectedTokenGetter?: ClerkTokenGetter | null
  sessionTokenGetter?: ClerkTokenGetter | null
}

export function createClerkAuthorizationHeaderGetter(options: ClerkAuthorizationHeaderOptions) {
  return async () => {
    const authTokenOptions = options.tokenTemplate ? { template: options.tokenTemplate } : undefined

    let token: string | null = null

    if (options.injectedTokenGetter) {
      try {
        token = await options.injectedTokenGetter(authTokenOptions)
      } catch {
        token = null
      }
    }

    if (!token && options.sessionTokenGetter) {
      try {
        token = await options.sessionTokenGetter(authTokenOptions)
      } catch {
        token = null
      }
    }

    if (!token) throw new Error('Clerk token unavailable: useAuth() context missing and Clerk session not accessible')

    return `Bearer ${token}`
  }
}
